import React from "react";

export const SkeletonCards = ({ count = 6, height = 200, min = 220 }) => (
  <div data-testid="loading-skeleton" style={{ display: "grid", gridTemplateColumns: `repeat(auto-fill,minmax(${min}px,1fr))`, gap: 16 }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="td-skeleton" style={{ height, borderRadius: 16 }} />
    ))}
  </div>
);

export const SkeletonRows = ({ count = 5, height = 64 }) => (
  <div data-testid="loading-skeleton" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="td-skeleton" style={{ height, borderRadius: 14 }} />
    ))}
  </div>
);

export const RetryNotice = ({ onRetry, label = "Impossible de charger pour le moment." }) => (
  <div data-testid="data-retry" style={{ padding: 28, borderRadius: 16, border: "1px solid var(--border-c)", background: "var(--bg-secondary)", textAlign: "center" }}>
    <p style={{ color: "var(--text-secondary)", margin: "0 0 14px", fontSize: 14 }}>{label}</p>
    <button onClick={onRetry} data-testid="data-retry-btn"
      style={{ padding: "10px 20px", borderRadius: 10, border: "none", background: "var(--brand)", color: "#fff", fontWeight: 800, cursor: "pointer" }}>
      Réessayer
    </button>
  </div>
);
